import React from "react";
import { FaDirections } from "react-icons/fa";
import { MdInfoOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setPlaceDetails } from "../../redux/action";

const PlaceDetails = ({ selectedPlace, randomImg,disabled,onClick }) => {

  const user_redux = useSelector((state) => state.user);
  const dispatch=useDispatch();


  return (
    <div
    onClick={()=>onClick?.(selectedPlace?.geo?.coordinates)}
      className={"place-map-detail-card"}
      style={{width:300}}
    >
      <img
        src={selectedPlace?.photos?.[0] || randomImg.current}
        alt={selectedPlace?.name}
        style={{
          width: "100%",
          height: "120px",
          objectFit: "cover",
          borderRadius: "8px",
          marginBottom: "8px",
        }}
      />

      <h5 style={{ margin: "2px 0", fontWeight: "600" }}>
        {selectedPlace?.name}
      </h5>

      <p style={{ fontSize: "12px", color: "#555", marginBottom: "6px" }}>
        📍 {selectedPlace?.location?.city}, {selectedPlace?.location?.country}
      </p>

      {selectedPlace?.categories?.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {selectedPlace.categories.map((cat) => (
            <span
              key={cat._id}
              style={{
                background: cat.color,
                color: "white",
                padding: "2px 6px",
                borderRadius: "6px",
                fontSize: "11px",
              }}
            >
              {cat.name}
            </span>
          ))}
        </div>
      )}

      {user_redux?.roles[0] === "contributor" && (
        <Link
        className=""
        state={selectedPlace}
          to={`/places/resturant/${selectedPlace?._id}`}
          style={{
            display: "flex",
            marginTop: "8px",
            fontSize: "13px",
            fontWeight: "bold",
            color: "#22025D",
            textDecoration: "none",
          }}
        >
          🔗 View Place
        </Link>
      )}
      {user_redux?.roles?.[0]==="user"&&!disabled&&(
         <Link
         className="text-decoration-underline gap-2 mt-3 align-items-center"
         state={selectedPlace}
           to={`/directions?id=${selectedPlace?._id}`}
           style={{
             display: "inline-flex",
             marginTop: "8px",
             fontSize: "13px",
             fontWeight: "bold",
             color: "#22025D",
             textDecoration: "none",
           }}
         >
          <FaDirections size={24}/> Get directions
         </Link> 
      )}
      <Link
      onClick={()=>dispatch(setPlaceDetails(selectedPlace))}
         className="text-decoration-underline gap-2 align-items-center"
         state={selectedPlace}
           to={selectedPlace?.link}
           style={{
             display: "flex",
             marginTop: "8px",
             fontSize: "13px",
             fontWeight: "bold",
             color: "#22025D",
             textDecoration: "none",
           }}
         >
          <MdInfoOutline size={24}/> View
         </Link> 
      
    </div>
  );
};

export default PlaceDetails;
